import script from "./ProductQuantityBottomBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductQuantityBottomBar.vue?vue&type=script&setup=true&lang=ts"

import "./ProductQuantityBottomBar.vue?vue&type=style&index=0&id=0478c606&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0478c606"]])

export default __exports__